import React, {useState, useEffect} from "react";
import Button from "react-bootstrap/Button";
import ApiService from "../util/ApiService";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import Swal from "sweetalert2";
import {Form} from "react-bootstrap";
import HospitalSearch from "./HospitalSearch";



const HospitalDepartmentRegisterModal = ({show, onHide, initialData = null, onSaveSuccess, hospital = null, department = null}) => {
    const [isSaving, setIsSaving] = useState(false);
    const [hospitalSelect, setHospitalSelect] = useState([]);

        const [formData, setFormData] = useState({
            id: '',
            time_start: '',
            time_end: '',
            duration_hours: '',
            qtde_user: '',
            department_id: '',
            hospital_id: '',
            order_month: [], // ← importante
            duty_scale_day_wee_id: [], // ← importante
        });

        const [departmentOptions, setDepartmentOptions] = useState([]);

        const formatTime = (time) => {
            return time ? time.slice(0, 5) : "";
        };

        useEffect(() => {
                if (show) {
                    if (initialData) {
                        const getArrayFromField = (field) => {
                            if (Array.isArray(field)) {
                                return field.map(String);
                            }
                            if (typeof field === "string") {
                                try {
                                    return JSON.parse(field).map(String);
                                } catch {
                                    return field.split(',').map(val => val.trim());
                                }
                            }
                            return [];
                        };
                        setTimeout(() => {
                        setFormData({
                            id: initialData.id || '',
                            hospital_id: hospital?.id || '',
                            department_id: initialData.department_id || '',
                            time_start: formatTime(initialData.time_start),
                            time_end: formatTime(initialData.time_end),
                            duration_hours_scale: formatTime(initialData.duration_hours_scale),
                            total_hours: formatTime(initialData.total_hours),
                            qtde_user: initialData.qtde_user || '',
                            order_month: getArrayFromField(initialData.order_month),
                            duty_scale_day_wee_id: getArrayFromField(initialData.duty_scale_day_wee_id),
                        })}, 0);
                    }  else {

                        setTimeout(() => {
                            setFormData({
                                hospital_id: hospital?.id,
                                id: '',
                                time_start: '',
                                time_end: '',
                                duration_hours_scale: '',
                                total_hours: '',
                                qtde_user: '',
                                department_id: department?.value,
                                order_month: [], // ← importante
                                duty_scale_day_wee_id: [], // ← importante
                            })
                        }, 0);
                    }


                }
            }, [show, initialData]
        );


        useEffect(() => {
            fetchDepartment();
            }, []
        );

        const fetchDepartment = async () => {
            try {
                const response = await ApiService.send('post', `${process.env.REACT_APP_URL_API}departments/list-department`, {
                    all: true,
                    status: 'S'
                }, true);
                const {data} = ApiService.handleApiResponse(response);
                const options = data.map(department => ({
                    value: department.id,
                    label: department.name,
                }));
                setDepartmentOptions(options);
            } catch (error) {
                ApiService.handleApiError(error);
            }
        };

        const handleInputChange = (e) => {
            const {name, value} = e.target;
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        };

        const handleSave = async () => {
            try {
                setIsSaving(true);
                const response = await ApiService.send(
                    'post',
                    `${process.env.REACT_APP_URL_API}departments-hospital/register`,
                    formData,
                    true
                );

                if (response?.code === 200) {
                    Swal.fire('Sucesso', 'Departamento salvo com sucesso!', 'success');
                    onHide(true);
                } else {
                    throw new Error(response?.data?.message || 'Erro ao salvar departamento.');
                }
            } catch (error) {
                ApiService.handleApiError(error);
            } finally {
                setIsSaving(false); // finaliza loading
            }
        };

        const handleSelectChange = (selectedOption) => {
            setFormData(prevData => ({
                ...prevData,
                department_id: selectedOption ? selectedOption.value : ''
            }));
        };

    const handleCheckboxChange = (e, fieldName) => {
        const value = e.target.value;
        const checked = e.target.checked;

        setFormData(prev => {
            const currentValues = prev[fieldName] || [];
            return {
                ...prev,
                [fieldName]: checked
                    ? [...currentValues, value]
                    : currentValues.filter(item => item !== value),
            };
        });
    };


    const onHospitalSelect = (hospital) => {
        setHospitalSelect(hospital);

        if(hospital){
            setFormData(prevData => ({
                ...prevData,
                hospital_id: hospital ? hospital.value : ''
            }));
        }


    };

        return (
            <Modal
                show={show}
                onHide={onHide}
                centered
                size="lg"
                backdrop="static"
                keyboard={false}
                backdropClassName="custom-backdrop"
                className="modal-filho"
            >

                <Modal.Header closeButton>
                    <Modal.Title>
                        Cadastrar Novo<br/>
                        <span className="text-sm" style={{fontSize: '12px'}}> Vagas Escala por Local</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <div className="row">
                            <div className="form-group col-4">
                                <label>Hora Início</label>
                                <input
                                    type="time"
                                    className="form-control"
                                    name="time_start"
                                    value={formData.time_start || ''}
                                    onChange={handleInputChange}
                                    placeholder="Digite a hora de início"
                                />
                            </div>
                            <div className="form-group col-4">
                                <label>Carga horária</label>
                                <input
                                    type="time"
                                    className="form-control"
                                    name="total_hours"
                                    value={formData.total_hours || ''}
                                    onChange={handleInputChange}
                                    placeholder="Digite a hora de término"
                                />
                            </div>
                            <div className="form-group col-4">
                                <label>Qtde Usuários</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="qtde_user"
                                    value={formData.qtde_user || ''}
                                    onChange={handleInputChange}
                                    placeholder="Digite a quantidade de usuários"
                                />
                            </div>
                            <div className="form-group col-6 mb-3">
                                <label>Departamento</label>
                                <Select
                                    isClearable={true}
                                    value={departmentOptions.find(option => option.value === formData.department_id) || department}
                                    onChange={handleSelectChange}
                                    options={departmentOptions}
                                    className="form-control"
                                    placeholder="Selecione o departamento"
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={{
                                        control: (base, state) => ({
                                            ...base,
                                            top: '-5px',
                                            border: 'none',
                                            boxShadow: 'none',
                                            backgroundColor: 'transparent',
                                            height: '23px', // ou outro valor como '32px', '40px'
                                            minHeight: '23px', // importante para garantir consistência
                                        }),
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 9999
                                        }),
                                        menu: base => ({
                                            ...base,
                                            zIndex: 9999
                                        }),
                                    }}
                                />
                            </div>
                            <div className="col-md-6">
                                <HospitalSearch
                                    buttonAdd={false}
                                    initialHospital={hospital}
                                    onHospitalSelect={onHospitalSelect}
                                />
                            </div>
                            <div className="col-12 form-group mt2">
                                <label>Ordem dentro do mês</label>
                                <div className="d-flex flex-wrap gap-2">
                                    {[0, 1, 2, 3, 4, 5].map(num => {
                                        // Se o checkbox 0 estiver marcado, esconde os outros
                                        if (formData.order_month.includes("0") && num !== 0) return null;

                                        return (
                                            <div key={num} className="form-check me-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`order-${num}`}
                                                    value={num}
                                                    checked={formData.order_month.includes(String(num))}
                                                    onChange={(e) => handleCheckboxChange(e, 'order_month')}
                                                />
                                                <label className="form-check-label" htmlFor={`order-${num}`}>
                                                    {num === 0 ? 'Todas as semanas' : `${num}ª Semana`}
                                                </label>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            <div className="col-12 form-group mt2">
                                <label>Dia da Semana</label>
                                <div className="d-flex flex-wrap gap-2">
                                    {[
                                        {id: 0, label: 'Dom'},
                                        {id: 1, label: 'Seg'},
                                        {id: 2, label: 'Ter'},
                                        {id: 3, label: 'Qua'},
                                        {id: 4, label: 'Qui'},
                                        {id: 5, label: 'Sex'},
                                        {id: 6, label: 'Sáb'},
                                    ].map(day => (
                                        <div key={day.id} className="form-check me-2">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`day-${day.id}`}
                                                value={day.id}
                                                checked={formData.duty_scale_day_wee_id.includes(String(day.id))}
                                                onChange={(e) => handleCheckboxChange(e, 'duty_scale_day_wee_id')}
                                            />
                                            <label className="form-check-label" htmlFor={`day-${day.id}`}>
                                                {day.label}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div className="mt-3">
                        <button type="button" className="btn btn-dark me-2" onClick={() => onHide()}>
                            <i className="fa fa-close"></i> Cancelar
                        </button>
                    <button type="button"  className="btn btn-primary me-2" onClick={() => handleSave()}
                            disabled={isSaving}>
                        {isSaving ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"></span>
                                Salvando...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-plus"></i>{' '}
                                {formData.id ? 'Alterar' : 'Cadastrar'}
                            </>
                        )}
                    </button>
                  </div>
                </Modal.Footer>

            </Modal>
        );
    }
;

export default HospitalDepartmentRegisterModal;
